import { createContext } from 'react';

import type { WalletAuthState } from './types';

export const WagmiAuthContext = createContext({} as WalletAuthState);
